import { render, staticRenderFns } from "./CommissionsHistoryModal.vue?vue&type=template&id=bdf95a04&scoped=true&"
import script from "./CommissionsHistoryModal.vue?vue&type=script&lang=ts&"
export * from "./CommissionsHistoryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf95a04",
  null
  
)

export default component.exports